'use client';

import React from 'react';

export function BitbucketIcon({
  className = 'text-ds-text-darker shrink-0',
  size = 20,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="currentColor"
      className={className}
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.023 4.066A1.938 1.938 0 0 0 .086 6.254L4.377 27.19a2.633 2.633 0 0 0 2.574 2.144h18.418a1.938 1.938 0 0 0 1.937-1.637l4.293-21.44a1.938 1.938 0 0 0-1.937-2.188zM19.66 21.25h-7.34l-1.98-10.5h11.22z" />
    </svg>
  );
}

/** Default GitHub Octocat icon (black). Reused across onboarding — e.g. RepositoryTeamReview, ChooseRepositoriesModal, TeamInsightConnectGitHub, PRBotSetup. */
export function GitHubIcon({
  className = 'text-ds-text-darker shrink-0',
  size = 20,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path
        fillRule="evenodd"
        d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.17 6.839 9.49.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.463-1.11-1.463-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.167 22 16.418 22 12c0-5.523-4.477-10-10-10z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function GitLabIcon({
  className = 'text-ds-text-darker shrink-0',
  size = 20,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 01-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 014.82 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0116.2 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.51 1.22 3.78a.84.84 0 01-.3.94z" />
    </svg>
  );
}

export function ProviderIcon({
  provider,
  size = 20,
  className,
}: {
  provider?: string;
  size?: number;
  className?: string;
}) {
  const p = provider?.trim().toLowerCase() ?? '';
  if (p === 'bitbucket')
    return <BitbucketIcon size={size} className={className} />;
  // Treat any non-empty, non-github, non-bitbucket provider as GitLab — this covers
  // 'gitlab', 'gitlab-self-hosted', and arbitrary self-hosted org slugs that NextAuth
  // uses as provider IDs (see isGitLabFamilyProvider.ts).
  if (p !== '' && p !== 'github')
    return <GitLabIcon size={size} className={className} />;
  return <GitHubIcon size={size} className={className} />;
}
